import { useEffect, useState } from "react";
import { getCachedVisitorGeo, resolveVisitorGeo } from "@/lib/visitor-geo";

/** Returns the visitor's ISO country code (uppercase) or null while resolving. */
export function useVisitorCountry(): string | null {
  const [code, setCode] = useState<string | null>(() => {
    const cached = getCachedVisitorGeo();
    return cached?.country_code ? cached.country_code.toUpperCase() : null;
  });

  useEffect(() => {
    if (code) return;
    let cancelled = false;
    resolveVisitorGeo()
      .then((geo) => {
        if (cancelled) return;
        setCode(geo.country_code ? geo.country_code.toUpperCase() : null);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [code]);

  return code;
}
